import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-typewriter',
    templateUrl: './typewriter.component.html',
    styleUrls: ['./typewriter.component.scss'],
    standalone: false
})

export class TypewriterComponent implements OnInit {
  text: string;
  vals = ['simple', 'meaningful', 'visible'];
  val;
  speed = 150;
  j = 0;
  i = 1;
  direction = false;
  constructor() { }

  ngOnInit() {
    this.type();
  }

  type() {
    this.text = this.getText();
    setTimeout(this.type.bind(this), this.speed);
  }
  getText() {
    if (this.j >= this.vals.length) {
      this.j = 0;
    }
    if (!this.text) {
      this.val = this.vals[this.j++];
    }
    if (this.val && this.i < this.val.length && !this.direction) {
      return this.val.substring(0, this.i++);
    } else if (this.val && this.i > 0 && this.direction) {
      return this.val.substring(0, this.i--);
    } else if (this.val) {
      this.direction = !this.direction;
      return this.val.substring(0, this.i);
    }
  }
}

